export default __webpack_public_path__ + "static/media/hipbaby_logo_horizontal_clear.e3eec7a7.png";